// Geographic altitude is presentation only. Every climb still simulates near
// its own origin, so larger route numbers never affect joints or collisions.
export const altitudeAt=(level,height)=>Math.max(0,(level.altitude||0)+height);
export const landingAltitude=level=>altitudeAt(level,level.height);
export const currentAltitude=game=>altitudeAt(game.level,game.status==='won'?game.level.height:game.height);
export const metres=value=>Math.floor(Math.max(0,value)).toLocaleString('en-US');

export function visibleAltitudeMarks(view,level){
  const top=174,bottom=view.h-(view.w<700?132:94);
  const localAt=y=>view.camera+(view.h*.81-(view.h*.5+(y-view.h*.5)/view.zoom))/view.scale;
  const base=level.altitude||0,low=Math.max(0,Math.ceil(base+localAt(bottom))),high=Math.floor(base+localAt(top));
  const marks=[];
  // Generate the visible interval, with no maximum altitude or fixed band.
  for(let altitude=low;altitude<=high;altitude++){
    const p=view.screenPoint(0,altitude-base);
    marks.push({altitude,y:p.y,major:altitude%5===0});
  }
  return {top,bottom,marks};
}
